import React from "react";
import Breadcrumb from "../../components/Breadcrumb";
import ChapterAdd from "../../components/Chapter/ChapterCreation";


const AddChapter = () => {
  return (
    <>
     

        {/* Breadcrumb */}
        <div className="d-flex justify-content-between"><h5>Add Chapter  </h5><Breadcrumb title="Add Chapter" /></div>

        {/* AddUserLayer */}
        <ChapterAdd />


    </>
  );
};

export default AddChapter;